module.exports = __webpack_public_path__ + "static/media/map-italy.3eeac38e.jpg";